import { useSyncExternalStore } from "react";
import { frontDoorPath } from "@softmax/web-features/coworlds";

import {
  coworldMenu,
  coworldSearchContext,
  type CoworldMenuItem,
} from "@softmax/web-features/site/records";
import type {
  CoworldNav,
  SiteSearchCoworldContext,
} from "@softmax/web-features/site/records";

type PillCoworld = {
  name: string;
  href: string;
  icon: string | null;
  items: CoworldMenuItem[];
  /** Its forum and wiki, for the pill's search. */
  search: SiteSearchCoworldContext;
};

let current: PillCoworld | null = null;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** The coworld whose rooms the account pill's menu lists, or null off a coworld. */
export function usePillCoworld(): PillCoworld | null {
  return useSyncExternalStore(
    subscribe,
    () => current,
    () => null,
  );
}

export function publishPillCoworld(nav: CoworldNav | null) {
  current = nav
    ? {
        name: nav.name,
        href: frontDoorPath({
          corpusSlug: nav.corpusSlug,
          route: { game: nav.route.game },
        }),
        icon: nav.icon,
        items: coworldMenu(nav),
        search: coworldSearchContext(nav),
      }
    : null;
  listeners.forEach((listener) => listener());
}
